/**
 * Bytecode opcodes and constants
 */

// Opcodes
export enum OpCode {
  PUSH,
  POP,
  DUP,
  ADD,
  SUB,
  MUL,
  DIV,
  POW,
  STORE,
  LOAD,
  OSC,
  FILTER,
  ENVELOPE,
  ENVELOPE_ADSR,
  DELAY,
  DATTORRO,
  SEQ_STEP,
  ARRAY_SUM,
  OUTPUT,
  SOLO,
  NOISE,
  ARRAY_PUSH,
  ARRAY_MAP,
  ARRAY_PICK,
  SIDECHAIN,
  CONV,
  SEQ_SLIDE,
  SEQ_ADV,
  SEQ_ADVSLIDE,
  SEQ_RAND,
  SEQ_RANDSLIDE,
  COMPRESSOR,
  EXPANDER,
  GATE,
  TANH,
  ATAN,
  POST,
  SAMPLE,
  PITCHSHIFT,
  FREEVERB,
  FDN,
  FDN2,
  SLICER,
  VELVET,
  LEXICON,
  SPRING,
  MTOF,
  TRANSPOSE,
  GRAIN,
  BEAT_GRAIN,
  KARPLUS,
  DC,
  VOCODER,
  LIMITER,
  SLEW,
  SAH,
  BITCRUSHER,
  SELECT,
  CROSSFADE,
  SWAP,
  HARMONICS,
  OSC_PWM,
  SOFT,
  ASYM,
  ENVELOPE_FOLLOWER,
  CHORUS,
  COMB,
  FLANGER,
  PUSH_ARRAY,
  ARRAY_METHOD_WALK,
  ARRAY_METHOD_SLIDE,
  ARRAY_METHOD_PICK,
  EUCLID,
  ARRAY_METHOD_EUCLID,
  SKIP,
  EVERY,
  ABS,
  SQRT,
  LOG,
  EXP,
  DB,
  MIN,
  MAX,
  CLAMP,
  WRAP,
  FLOOR,
  CEIL,
  FRACT,
  SIGN,
  PUSH_CLOCK,
  SUBDIVIDE,
  AMPLITUDE,
  LFO,
  TIMELINE,
}

// DSP type encodings
export const enum OscType {
  SIN,
  TRI,
  SAW,
  SQR,
  RAMP,
  PHASOR,
}

export const enum FilterType {
  LP,
  HP,
  BP,
  SVFLP,
  SVFHP,
  SVFBP,
  SVFNOTCH,
  SVFPEAK,
  SVFALLPASS,
  BS,
  NOTCH,
  LS,
  HS,
  PEAK,
  ALLPASS,
  DIODELADDER,
  MOOGLP,
  MOOGHP,
  FFTHP,
  EQ3,
  ONEPOLE,
}

export const enum DelayType {
  DELAY,
  BEAT_DELAY,
}

export const enum LfoType {
  SIN,
  TRI,
  SAW,
  RAMP,
  SQR,
  PWM,
  SAH,
}
